import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    $(".place-image-helper").removeClass('d-none');
    $(".place-image-helper").addClass('mb-3')
  }
}